export const rootLevelOrImageDragTargets = {
  defaultRules: false,
  edgeDetection: "none",
  rules: [
    {
      id: "root-level-or-image",
      evaluate: ({ node, depth }) => {
        if (node.type.name === "image") return 0
        return depth === 1 ? 0 : 1000
      },
    },
  ],
}
